import { useContext, useEffect, useRef, useState } from 'react'
import { fetchJobsData } from "../../services/Candidate Portal/fetchJobsApi"
import { toggleJobSave } from "../../services/Candidate Portal/jobApplications"
import { getHiringStatusClass, handleSearchTextChange, handleSearchKeyDown, handleSearch,
    handlePerPageChange, goToPage  } from "../../utils/Candidate Portal/JobList"
import { IoSearch } from "react-icons/io5";
import { DataProvider } from '../../store/ContextProvider'
import Loading from '../Loading'
import { renderImgSrc } from '../../utils/renderImgSrc'

function JobList({ page }) {

    const { BeURL, showAlert } = useContext(DataProvider)

    const [tempSearchTerm, setTempSearchTerm] = useState("")
    const [searchTerm, setSearchTerm] = useState("")
    const [pagination, setPagination] = useState({
        currentPage: 1,
        perPage: 5,
        totalPages: 0,
        totalCount: 0
    })
    const [jobs, setJobs] = useState(null)
    const jobType = {
        ft: "Full time",
        pt: "Part time",
        contract: "Contract"
    }

    const paginationRef = useRef(pagination)
    const searchTermRef = useRef(searchTerm)


    // sync refs whenever these values change
    useEffect(() => { paginationRef.current = pagination }, [pagination])
    useEffect(() => { searchTermRef.current = searchTerm }, [searchTerm])

    const fetchJobs = () => {
        const currSearch = searchTermRef.current
        const currCurrPage = paginationRef.current.currentPage
        const currPerPage = paginationRef.current.perPage


        fetchJobsData(BeURL, showAlert, currSearch, page, currCurrPage, currPerPage, setJobs, setPagination)
    }
    const handleJobSaveRemoval = (id) => toggleJobSave(BeURL, showAlert, id, false)

    useEffect(() => {
        let fetchData;
        if (BeURL) {
            fetchJobs()
            fetchData = setInterval(() => {
                fetchJobs()
            }, 5000)
        }

        return () => clearInterval(fetchData)
    }, [BeURL])

    if (!jobs || !BeURL) {
        return <Loading/>
    };

    return (
        <div className="py-6 min-h-[70vh]">
            <h2 className='my-3 font-medium text-xl text-center'>{page === "applied" ? "Applied Jobs" : "My Bucket List"}</h2>

            <div className='flex flex-wrap justify-center items-center gap-3 my-2'>
                <div className='flex items-stretch w-full md:w-[40%]'>
                    <span className='pl-4 py-2 rounded-l-lg bg-white flex items-center justify-center'>
                        <IoSearch />
                    </span>
                    <input className='pr-4 pl-1 py-2 rounded-r-lg outline-none w-full' type='search' value={tempSearchTerm} onChange={e => handleSearchTextChange(e, setTempSearchTerm, setSearchTerm, fetchJobs)} onKeyDown={e => handleSearchKeyDown(e, setSearchTerm, fetchJobs)} placeholder='Search by title, description, or location' />
                </div>
                <button className='px-4 py-2 rounded-lg text-white bg-primary-300' onClick={() => handleSearch(tempSearchTerm, setSearchTerm, fetchJobs)}>Search</button>
            </div>

            <div className='w-full overflow-auto min-h-[55vh]'>
                <table className='w-full'>
                    <thead>
                        <tr className=' text-secondary-300 font-medium mb-2 rounded-lg shadow'>
                            <th className='bg-purple-100 px-4 py-6 rounded-l-lg'>S. No.</th>
                            <th className='bg-purple-100 px-4 py-6'>{page === "applied" ? "Applied at" : "Saved at"}</th>
                            <th className='bg-purple-100 px-4 py-6 text-left'>Job</th>
                            <th className='bg-purple-100 px-4 py-6 rounded-r-lg'>{page === "applied" ? "Status" : "Action"}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            jobs.map((job, i) => (
                                <tr className='rounded-lg shadow text-center'>
                                    <td className='px-4 py-3'>{i + 1}</td>
                                    <td className='px-4 py-3'>{new Date(page === "applied" ? job.appliedAt : job.savedAt).toLocaleDateString("en-GB")}</td>
                                    <td className='px-4 py-3'>
                                        <div className='flex justify-start gap-3 items-center'>
                                            <img className='h-[50px] aspect-square object-contain bg-purple-50 rounded-full shadow-lg hidden sm:block' src={renderImgSrc(job.job.createdBy?.companyLogo || "", job.job.createdBy?.companyName || "")} alt={job.job.createdBy?.companyName || ""} />
                                            <div className='text-left'>
                                                <h3 className='font-medium text-primary-300 hover:cursor-pointer hover:text-primary-400' onClick={() => window.open(`/job/${job.job._id}`, "_blank")}>
                                                    {job.job.title || ""}
                                                </h3>
                                                <p className='sm:flex flex-wrap gap-2 items-center justify-start hidden'>
                                                    <span>{(job.job.location?.city) || ""}</span>
                                                    <span>{(job.job.location?.type) ? ` - ${job.job.location?.type}` : ""}</span>
                                                    <span>{job.job.employmentType ? ` - ${jobType[job.job.employmentType] || ""}` : ""}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className='px-4 py-3'>
                                        {page === "applied" ?
                                            <div className={`
                                                px-3 py-1 rounded-lg inline-block text-sm font-medium ${getHiringStatusClass(job.hiringStatus)}
                                                `}>{job.hiringStatus}</div>
                                            :
                                            <div>
                                                <button className='text-red-600 border-[0.5px] border-red-600 px-4 py-1 rounded-lg' onClick={() => handleJobSaveRemoval(job._id)}>Remove</button>
                                            </div>
                                        }
                                    </td>
                                </tr>
                            ))
                        }

                    </tbody>
                </table>
            </div>

            {/* Pagination (driven by backend totalPages state) */}
            <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-3">

                <div className="flex items-center justify-center gap-3 flex-1">
                    <label className="text-sm">Items per page</label>
                    <select value={pagination.perPage} onChange={e => handlePerPageChange(e, setPagination)} className="border rounded-md px-3 py-2">
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>

                <div className="flex items-center justify-center gap-2 flex-1">
                    <button
                        onClick={() => goToPage(Math.max(1, pagination.currentPage - 1), setPagination)}
                        disabled={pagination.currentPage <= 1}
                        className={`px-3 py-2 rounded-md border ${pagination.currentPage <= 1 ? "opacity-50 cursor-not-allowed" : "bg-slate-500 text-white"}`}
                    >
                        Prev
                    </button>

                    {pagination.currentPage} of {pagination.totalPages || 1}

                    <button
                        onClick={() => goToPage(Math.min(pagination.totalPages || 1, pagination.currentPage + 1), setPagination)}
                        disabled={pagination.currentPage >= (pagination.totalPages || 1)}
                        className={`px-3 py-2 rounded-md border ${pagination.currentPage >= (pagination.totalPages || 1) ? "opacity-50 cursor-not-allowed" : "bg-slate-500 text-white"}`}
                    >
                        Next
                    </button>
                </div>

                <div className="text-sm text-slate-600 flex-1 text-center">
                    Total {pagination.totalCount || 0} result{pagination.totalCount <= 1 ? "" : "s"}
                </div>

            </div>
        </div>
    )
}

export default JobList